import { render, staticRenderFns } from "./AssignProgramDialog.vue?vue&type=template&id=006ce522&scoped=true"
import script from "./AssignProgramDialog.vue?vue&type=script&lang=js"
export * from "./AssignProgramDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignProgramDialog.vue?vue&type=style&index=0&id=006ce522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ce522",
  null
  
)

export default component.exports